import { render } from "./TaxesEdit.vue?vue&type=template&id=535c292c&scoped=true"
import script from "./TaxesEdit.vue?vue&type=script&lang=js"
export * from "./TaxesEdit.vue?vue&type=script&lang=js"

import "./TaxesEdit.vue?vue&type=style&index=0&id=535c292c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535c292c"]])

export default __exports__